import { useMemo } from 'react';
import { useNavBarContext } from 'src/components/NavBarContext/NavBarContext';
import { useCMS } from 'src/hooks/useCMS';
import { flattenContentfulData } from 'src/services/cms/flattenContentful';
import { getFlattenedMainMenu, getFlattenedUtilMenu } from 'src/services/cms/navigation/flattenNavigation';

/**
 * Hook that gets CMS-agnostic data for Navigation
 * @returns returns CMS-agnostic data for Navigation
 * @example const { mainMenu, utilMenu } = useCMSNavigation();
 */
export const useCMSNavigation = () => {
  const mainMenu = useCMS(getFlattenedMainMenu);
  const utilMenu = useCMS(getFlattenedUtilMenu);

  const { headerOverride, headerUtilOverride } = useNavBarContext();

  const navData = useMemo(() => ({
    mainMenu: headerOverride ? flattenContentfulData(headerOverride) : mainMenu,
    utilMenu: headerUtilOverride ? flattenContentfulData(headerUtilOverride) : utilMenu,
  }), [mainMenu, utilMenu, headerOverride, headerUtilOverride]);

  return navData;
};
